import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {AslDeviceOverviewContext} from "../context/AslDeviceOverviewContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"

const DeleteAslGuidedDivertConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {open, setOpen} = props;
    const {viewModel, dispatch} = useContext(AslDeviceOverviewContext);
    const [valueDivertCode, setValueDivertCode] = useState("")
    const [searchQuery, setSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        setInputState();
    }

    const stateValues = {
        divertCode: valueDivertCode,
        mac: mac
    }

    const divertConfigList = viewModel.aslDeviceInformation[mac].divertConfig.map(({divertCode}) => divertCode);
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i")
    const matchedOptions = divertConfigList.filter(
        option => !searchQuery || searchRegExp.test(option)
    )

    const onClickConfirm = (stateValues) => {
        deleteData(stateValues);
        setOpen(false)
        setInputState();
    }

    function setInputState() {
        setValueDivertCode("");
    }

    const deleteData = (stateValues) => {
        dispatch({
            type: 'DELETE_DEVICE_CONFIG_DATA',
            data: {dispatcher: dispatch, mac: stateValues.mac, divertCode: stateValues.divertCode}
        })
    }

    return (
        <Modal
            title={formatMessage({id: "device.delete_divert_config_button_modal"})}
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Column spacing={"medium"} spacingInset={"small"}>
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    <FormattedMessage id="modal.divertcodedelete" defaultMessage="Please enter the Divert Code you would like to remove"/>
                </Text>
                <Select
                    value={valueDivertCode}
                    onChange={setValueDivertCode}
                    searchQuery={searchQuery}
                    onSearch={setSearchQuery}
                    placeholder="Select divert code to be deleted."
                    width={300}>
                    {matchedOptions.map((divertCode) => (
                        <SelectOption key={divertCode} value={divertCode} label={divertCode}/>
                    ))}
                    {!matchedOptions.length ? (
                        <Column alignmentVertical="center" spacing="100" spacingInset="100">
                            {divertConfigList ? <Text alignment="center"> No matching divert codes </Text>
                                : <Text alignment="center"> No divert codes available </Text>}
                        </Column>) : null}
                </Select>
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium"
                            onClick={() => onClickConfirm(stateValues)}>
                        <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(DeleteAslGuidedDivertConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/modal/DeleteAslGuidedDivertConfigurationModal.js